import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {PropertyGroup} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/Prop';
import {SystemPropsConfigs} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/SystemPropsConfigs';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {createProp} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/migrations/0->1-migration';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';

const MIGRATED_VERSION:DesignerVersion = 15;

export const migration_14_15:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        if( designState.surface && designState.surface.pages )
        {
            Object.values(designState.surface.pages).forEach((page:any) =>
            {
                if( page.artboard && page.artboard.allBoxes )
                {
                    Object.values(page.artboard.allBoxes).forEach((boxSnapshot:any) =>
                    {
                        const {componentDesc} = boxSnapshot;

                        const layoutRightPropSnapshot:any = createProp(
                            componentDesc.boxId,
                            componentDesc.visualComponentId,
                            SystemPropsConfigs.layoutPropertiesConfigs.get(SystemPropsConfigs.LAYOUT_RIGHT_PROP_NAME),
                            PropertyGroup.Layout
                        );

                        const layoutBottomPropSnapshot:any = createProp(
                            componentDesc.boxId,
                            componentDesc.visualComponentId,
                            SystemPropsConfigs.layoutPropertiesConfigs.get(SystemPropsConfigs.LAYOUT_BOTTOM_PROP_NAME),
                            PropertyGroup.Layout
                        );

                        const layoutVerticalPropSnapshot:any = createProp(
                            componentDesc.boxId,
                            componentDesc.visualComponentId,
                            SystemPropsConfigs.layoutPropertiesConfigs.get(SystemPropsConfigs.LAYOUT_VERTICAL_PROP_NAME),
                            PropertyGroup.Layout
                        );

                        const layoutHorizontalPropSnapshot:any = createProp(
                            componentDesc.boxId,
                            componentDesc.visualComponentId,
                            SystemPropsConfigs.layoutPropertiesConfigs.get(SystemPropsConfigs.LAYOUT_HORIZONTAL_PROP_NAME),
                            PropertyGroup.Layout
                        );

                        const layoutKeepProportionsPropSnapshot:any = createProp(
                            componentDesc.boxId,
                            componentDesc.visualComponentId,
                            SystemPropsConfigs.layoutPropertiesConfigs.get(SystemPropsConfigs.LAYOUT_KEEP_PROPORTIONS_PROP_NAME),
                            PropertyGroup.Layout
                        );

                        componentDesc._layoutProperties[layoutRightPropSnapshot.id] = layoutRightPropSnapshot;
                        componentDesc._layoutProperties[layoutBottomPropSnapshot.id] = layoutBottomPropSnapshot;
                        componentDesc._layoutProperties[layoutVerticalPropSnapshot.id] = layoutVerticalPropSnapshot;
                        componentDesc._layoutProperties[layoutHorizontalPropSnapshot.id] = layoutHorizontalPropSnapshot;
                        componentDesc._layoutProperties[layoutKeepProportionsPropSnapshot.id] = layoutKeepProportionsPropSnapshot;
                    });
                }
            });
        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};
